import React from 'react';
import NotifyStream from './NotifyStream';
import { NotifyToastHost } from './notifyToast';

/** SSE listener + in-app toast host for logged-in users */
const NotifyProvider: React.FC = () => {
  return (
    <>
      <NotifyStream />
      <NotifyToastHost />
    </>
  );
};

export default NotifyProvider;
